import { createApp } from 'vue'
import App from './App.vue'
import './assets/style/tailwind.css'
import './assets/style/index.scss'
import "virtual:svg-icons-register";
import { setupApp } from './utils/appConfig';

export const app = createApp(App)
setupApp(app);

app.mount('#app')

// if (import.meta.env.DEV) {
//   window.onerror = function(message, source, lineno, colno, error) {
//     // 显示错误提示
//     alert(`请注意控制台错误: ${message}, 来源: ${source}, 行号: ${lineno}, 列号: ${colno}, 错误: ${error}`);
//     // 可以在这里添加错误日志上报
//     return false; // 阻止默认错误处理
//   };
//   window.onunhandledrejection = function(event) {
//     alert(`请注意控制台错误: onunhandledrejection ${event.reason}`);
//     // 阻止默认处理
//     // event.preventDefault();
//   };
// }

